export enum Menu {
  NONE = 'none',
  USER_MENU = 'user-menu',
  CART_MENU = 'cart-menu',
}
